import { authenticated } from '../../../helpers/auth-header';
import insighttAPI from '../../../services/clients/insightt-api-client';
import { tourEndpoints } from '../../../services/endpoints/tour.endpoints';

export const getTourCompletionStatus = async (title) =>
  new Promise((resolve, reject) => {
    authenticated(insighttAPI)
      .get(tourEndpoints.getTourCompletionStatusAPI(title))
      .then((response) => {
        if (response.ok) {
          const completed = response.data.completed;

          resolve(completed);
        } else {
          reject(response);
        }
      })
      .catch((err) => reject(err));
  });

export const completeTour = async (title) =>
  new Promise((resolve, reject) => {
    authenticated(insighttAPI)
      .post(tourEndpoints.completeTourAPI(title))
      .then((response) => {
        if (response.ok) {
          resolve();
        } else {
          reject(response);
        }
      })
      .catch((err) => reject(err));
  });
